import { StringUtils } from './string.utils';
import { ObjectUtils } from './object.utils';

export enum SearchFilterOperator {
  Equal = ':',
  Lower = '<',
  Greater = '>',
}

export class SearchFilterItem {
  constructor(
    public name: string,
    public value: any,
    public operator: SearchFilterOperator
  ) {}
}

export class SearchQueryBuilder {
  private queryTerms = new Array<SearchFilterItem>();

  public add(
    name: string,
    value: any,
    operator: SearchFilterOperator = SearchFilterOperator.Equal
  ): SearchQueryBuilder {
    if (StringUtils.isEmpty(name) || ObjectUtils.isEmpty(value)) {
      return this;
    }

    const item = this.find(name, operator);

    if (item) {
      item.value = value;
    } else {
      this.queryTerms.push(new SearchFilterItem(name, value, operator));
    }

    return this;
  }

  public toogle(
    name: string,
    value: any,
    operator: SearchFilterOperator = SearchFilterOperator.Equal
  ) {
    if (value) {
      this.add(name, value, operator);
    } else {
      this.remove(name, operator);
    }
  }

  public remove(
    name: string,
    operator: SearchFilterOperator
  ): SearchQueryBuilder {
    this.queryTerms = this.queryTerms.filter(
      (value: SearchFilterItem, index: number, array: SearchFilterItem[]) => {
        if (operator) {
          return !(value.name === name && operator === value.operator);
        }
        return value.name !== name;
      }
    );

    return this;
  }

  public find(
    name: string,
    operator: SearchFilterOperator
  ): SearchFilterItem | undefined {
    return this.queryTerms.find(
      (value: SearchFilterItem, index: number, array: SearchFilterItem[]) => {
        return value.name === name && operator === value.operator;
      }
    );
  }

  public clear(): void {
    this.queryTerms.length = 0;
  }

  public build(): string {
    let result = '';
    this.queryTerms.forEach((value: SearchFilterItem) => {
      result += `${value.name}${value.operator}${value.value},`;
    });

    if (result.length > 0) {
      return result.slice(0, -1);
    } else {
      return result;
    }
  }
}
